import { deburr } from 'lodash';
function makeComparableString(input) {
    return deburr(input).trim().toLowerCase();
}
export function stringIncludes(target, source) {
    return makeComparableString(target).includes(makeComparableString(source));
}
